// extracted by mini-css-extract-plugin
export default {"container":"container__JMR5Y","title":"title__CuwG0","subtitle":"subtitle__BIcAf","list":"list__4dPyg"};